import {Map, fromJS, List} from "immutable";

import {
    GET_PROJECTS_SUCCESS,
    GET_PROJECTS_REQUEST,
    GET_PROJECTS_ERROR,
    GET_PROJECT_REQUEST,
    GET_PROJECT_SUCCESS,
    GET_PROJECT_ERROR,
    CREATE_PROJECT_REQUEST,
    CREATE_PROJECT_SUCCESS,
    CREATE_PROJECT_ERROR,
    UPDATE_PROJECT_REQUEST,
    UPDATE_PROJECT_SUCCESS,
    UPDATE_PROJECT_ERROR,
    CHANGE_STATUS_PROJECT_REQUEST,
    CHANGE_STATUS_PROJECT_SUCCESS,
    CHANGE_STATUS_PROJECT_ERROR,
    REGISTER_PROBLEM_REQUEST,
    REGISTER_PROBLEM_SUCCESS,
    REGISTER_PROBLEM_ERROR,
    DELETE_PROBLEM_REQUEST,
    DELETE_PROBLEM_SUCCESS,
    DELETE_PROBLEM_ERROR,
    UPLOAD_PROJECT_FILES_REQUEST,
    UPLOAD_PROJECT_FILES_PROGRESS,
    UPLOAD_PROJECT_FILES_SUCCESS,
    UPLOAD_PROJECT_FILES_ERROR,
    DELETE_PROJECT_FILE_REQUEST,
    DELETE_PROJECT_FILE_SUCCESS,
    DELETE_PROJECT_FILE_ERROR,
    DELETE_PROJECT_REQUEST,
    DELETE_PROJECT_SUCCESS,
    DELETE_PROJECT_ERROR,
    CLEAN_PROJECTS
} from '../actions/projects';

const projects = (state = Map({
    payload: List([]),
    isFetching: false,
    isUploading: false,
    error: false
}), action) => {
  let newState, updatedPayload, index, payload = state.get('payload');
  switch (action.type) {

      // Requests
      case GET_PROJECTS_REQUEST:
      case GET_PROJECT_REQUEST:
      case CREATE_PROJECT_REQUEST:
      case UPDATE_PROJECT_REQUEST:
      case CHANGE_STATUS_PROJECT_REQUEST:
      case REGISTER_PROBLEM_REQUEST:
      case DELETE_PROBLEM_REQUEST:
      case DELETE_PROJECT_FILE_REQUEST:
      case DELETE_PROJECT_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;
      case UPLOAD_PROJECT_FILES_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              isUploading: true,
              error: action.error,
              percent: 0
          });
          return newState;

      // Progress
      case UPLOAD_PROJECT_FILES_PROGRESS:
          newState = state.merge({
              percent: action.percent
          });
          return newState;

      // Success
      case GET_PROJECTS_SUCCESS:
      case GET_PROJECT_SUCCESS:
      case CLEAN_PROJECTS:
          newState = state.merge({
              payload: fromJS(action.payload),
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      case CREATE_PROJECT_SUCCESS:

          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              updatedPayload = payload.push(fromJS(action.payload));

              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(payload)) {
              updatedPayload = fromJS(action.payload);
          }

          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              created: action.created,
              payload: updatedPayload
          });
          return newState;

      case UPDATE_PROJECT_SUCCESS:
      case CHANGE_STATUS_PROJECT_SUCCESS:
      case REGISTER_PROBLEM_SUCCESS:
      case UPLOAD_PROJECT_FILES_SUCCESS:
      case DELETE_PROJECT_FILE_SUCCESS:
      case DELETE_PROBLEM_SUCCESS:

          // Check if payload is a List (Array)
          if(List.isList(payload)) {

              // Find the index of the project to be updated inside the List
              index = payload.findIndex(item => {
                  return item.get('_id') === action.payload._id;
              });

              // Update the payload list
              if (index !== -1) {
                  updatedPayload = payload.update(index, () => {
                      return fromJS(action.payload);
                  });
              }


              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(state.get('payload'))) {
              updatedPayload = fromJS(action.payload);
          }
          newState = state
              .merge({
                  isFetching: action.isFetching,
                  isUploading: false,
                  percent: 0,
                  error: action.error,
                  updated: action.updated,
                  payload: updatedPayload
              });
          return newState;
      case DELETE_PROJECT_SUCCESS:
          updatedPayload = payload.filter( project => {
              return project.get('_id') !== action.payload._id;
          });
          newState = state.merge({
              payload: updatedPayload,
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Errors
      case GET_PROJECTS_ERROR:
      case GET_PROJECT_ERROR:
      case CREATE_PROJECT_ERROR:
      case UPDATE_PROJECT_ERROR:
      case CHANGE_STATUS_PROJECT_ERROR:
      case REGISTER_PROBLEM_ERROR:
      case DELETE_PROBLEM_ERROR:
      case UPLOAD_PROJECT_FILES_ERROR:
      case DELETE_PROJECT_FILE_ERROR:
      case DELETE_PROJECT_ERROR:
          newState = state.merge({
              isFetching: action.isFetching,
              isUploading: false,
              percent: 0,
              error: action.error,
              errorMessage: action.errorMessage
          });
          return newState;
      default:
          return state;
  }
};

export default projects;



// WEBPACK FOOTER //
// ./src/reducers/projects.js